import { useLazyQuery, useMutation } from "@apollo/client/react"; import { CircularProgress, Grid } from '@mui/material';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { RenderInputsRowByType } from '../../../../components/formGroupGenerator/RenderInputRowByType';
import moment from 'moment';
import { adaptCondicionesContrato, GET_CONDICIONES_CONTRATO } from '../../../../data/graphQL/queries/Contratos/getCondicionesContrato';
import { adaptCondicionesContratoPlan, GET_CONDICIONES_CONTRATO_BY_PLAN } from '../../../../data/graphQL/queries/Contratos/getCondicionesContratoByPlan';

import { SOLICITAR_AUTORIZACION } from '../../../../data/graphQL/mutations/Contratos/SolicitarAutorizacion';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import { GET_AUTORIZACION_CONTROL } from '../../../../data/graphQL/queries/Contratos/getAutorizacionControlInProgress';
import toast from 'react-hot-toast';
import { AJUSTAR_FECHA_HASTA_PRIMERA_CONEXION } from '../../../../data/graphQL/mutations/Contratos/ajustarFechaHasta';
import { AJUSTAR_FECHA_HASTA_DIAS_CORRIDO } from '../../../../data/graphQL/mutations/Contratos/ajustarFechaHastaDiasCorrido';
import { adaptEvaluacionCondicionInput, UPDATE_EVALUACION_CONDICION } from '../../../../data/graphQL/mutations/Contratos/UpdateEvaluacionCondicion';
import { CompareDates, DateDiff } from '../../../../utils/helpers';
import { GroupedContainer } from '../GroupedContainer';

const RESULTADO_PRESUPUESTO_APROBADO = 1;

export const TabCondicionesContrato = ({
  contratoEditable,
  origen,
  fullFormData,
  requisitoCliente,
  stepData,
  handleChangeFullFormData,
  setDataSubmissionCallback,
  idEvaluacion,
  allowedWrite,
  pageLoading,
  setPageLoading
}) => {

  const [condicionesContrato, setCondicionesContrato] = useState(stepData?.condicionesContrato ?? {});
  const [autControlInProgress, setAutControlInProgress] = useState(false);
  const [fechaPrimeraConexion, setFechaPrimeraConexion] = useState(false);
  const [fechaDiasCorrido, setFechaDiasCorrido] = useState(false);
  const [editaFechaHasta, setEditaFechaHasta] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleChangeFullFormData('condicionesContrato', condicionesContrato);
    }, 600);

    return () => clearTimeout(timer);
  }, [condicionesContrato]);

  useEffect(() => {
    setEditaFechaHasta(requisitoCliente.editaFechaHasta);
  }, [requisitoCliente]);

  useEffect(() => {
    let diasContrato = 0;
    const desde = moment(condicionesContrato.fechaDesde);
    const hasta = moment(condicionesContrato.fechaHasta);

    diasContrato = hasta.diff(desde, 'days') > 0 ? hasta.diff(desde, 'days') + 1 : diasContrato;

    if (!!condicionesContrato?.diasCorridosContrato && fullFormData.gestionPresupuestos.fechaEnvioPresupuesto != null)
      handleChange('diasContrato', condicionesContrato?.diasCorridosContrato); else

      handleChange('diasContrato', diasContrato);
  }, [
    condicionesContrato.fechaDesde,
    condicionesContrato.fechaHasta,
    condicionesContrato.diasCorridosContrato,
    fullFormData.gestionPresupuestos.fechaEnvioPresupuesto]
  );

  useEffect(() => {
    if (!idEvaluacion || !!fullFormData?.evaluacionAsistencial?.idModulo) return;
    getCondicionesContrato({ variables: { idEvaluacion } });
    setAutorizacionInProgress();
  }, [idEvaluacion, fullFormData?.evaluacionAsistencial?.idModulo]);

  useEffect(() => {
    if (!idEvaluacion || !fullFormData?.evaluacionAsistencial?.idModulo) return;
    getCondicionesByPlan();
  }, [fullFormData?.evaluacionAsistencial?.idModulo]);

  const getCondicionesByPlan = async () => {
    try {
      const { data } = await getCondicionesContratoByPlan({
        variables: {
          idEvaluacion: idEvaluacion,
          idPlanCuidado: fullFormData?.evaluacionAsistencial?.idModulo
        }
      });
      const condicionesContrato = adaptCondicionesContratoPlan(data);
      setCondicionesContrato((prevForm) => ({
        ...prevForm,
        ...condicionesContrato
      }));
    } catch (error) {
      console.error("Error al obtener condiciones por plan:", error);
    }
  };

  const setAutorizacionInProgress = async () => {
    try {
      const { data } = getAutorizacionInProgress({ variables: { idEvaluacion } });
      setAutControlInProgress(data?.autorizacionControlInProgress);
    } catch (error) {
      console.error("Error al obtener condiciones por plan:", error);
    }
  };

  const [getCondicionesContrato, { data: dataCondicionesContrato }] = useLazyQuery(GET_CONDICIONES_CONTRATO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataCondicionesContrato) return;
    const condicionesContrato = adaptCondicionesContrato(dataCondicionesContrato);
    setCondicionesContrato((prevForm) => ({
      ...prevForm,
      ...condicionesContrato
    }));
  }, [dataCondicionesContrato]);

  const [getCondicionesContratoByPlan] = useLazyQuery(GET_CONDICIONES_CONTRATO_BY_PLAN, {
    fetchPolicy: 'no-cache'
  });

  const [ajustarPrimeraConexion] = useMutation(AJUSTAR_FECHA_HASTA_PRIMERA_CONEXION, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      let fechaHasta = data.ajustarFechaHastaPrimeraConexion;
      if (fechaHasta != null) {
        setCondicionesContrato((prevForm) => ({
          ...prevForm,
          fechaHasta: fechaHasta
        }));
        toast.success('La fecha se ajusto correctamente');
        setFechaPrimeraConexion(true);
      } else {
        toast.error('No se pudo ajustar la fecha');
      }
    }
  });

  const [ajustarFechaHastaDiasCorrido] = useMutation(AJUSTAR_FECHA_HASTA_DIAS_CORRIDO, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      let fechaHasta = data.ajustarFechaHastaDiasCorrido;
      if (fechaHasta != null) {
        setCondicionesContrato((prevForm) => ({
          ...prevForm,
          fechaHasta: fechaHasta
        }));
        toast.success('La fecha se ajusto correctamente');
        setFechaDiasCorrido(true);
      } else {
        toast.error('No se pudo ajustar la fecha');
      }
    }
  });

  const [getAutorizacionInProgress] = useLazyQuery(GET_AUTORIZACION_CONTROL, {
    fetchPolicy: 'no-cache'
  });

  const [updateEvaluacionCondicion] = useMutation(UPDATE_EVALUACION_CONDICION);

  const handleSubmit = () => {
    setPageLoading(true);
    const inputEvaluacionCondicion = adaptEvaluacionCondicionInput(idEvaluacion, condicionesContrato);
    updateEvaluacionCondicion({
      variables: {
        input: inputEvaluacionCondicion
      }
    }
    ).catch(() => {
      toast('Error al guardar condiciones de contrato');
    }).finally(() => {
      setPageLoading(false);
    });
  };

  const [solicitarAutorizacion, { loading: solicitarLoading }] = useMutation(SOLICITAR_AUTORIZACION, {
    variables: {
      idEvaluacion,
      observacion: condicionesContrato.observacion,
      precio: condicionesContrato.precioDiario
    },
    onCompleted: () => {
      toast.success('¡Solicitud de autorización enviada!');
      setAutorizacionInProgress();
      getCondicionesByPlan();
    },
    onError: () => {
      toast.error('No se pudo enviar la solicitud, intente más tarde.');
    }
  });

  const handleChange = (name, value) => {
    if (name != 'fechaDesde' && name != 'fechaHasta') {
      setCondicionesContrato((prevForm) => ({
        ...prevForm,
        [name]: value
      }));
    } else {
      handleChangeFecha(name, value);
    }
  };

  const isValidFecha = (name, value) => {
    if (name == 'fechaDesde') {
      return !!condicionesContrato.fechaHasta ?
        CompareDates(new Date(value), new Date(condicionesContrato.fechaHasta)) <= 0 :
        true;
    } else

      return CompareDates(new Date(condicionesContrato.fechaDesde), new Date(value)) <= 0;
  };

  const handleChangeFecha = (name, value) => {
    if (!isValidFecha(name, value)) {
      toast.error('La fecha desde debe ser menor o igual a la fecha hasta');
      setCondicionesContrato((prevForm) => ({
        ...prevForm,
        [name]: null
      }));
    } else {
      if (condicionesContrato.cotizado) {
        let dias = DateDiff(new Date(name === 'fechaDesde' ? moment(value) : moment(condicionesContrato.fechaDesde)),
          new Date(name === 'fechaHasta' ? moment(value) : moment(condicionesContrato.fechaHasta)));
        //Se valida con 91 días porque el último día se contea como parte del contrato
        //y el contrato no puede ser mayor a 92 días.
        if (dias > 91) {
          setCondicionesContrato((prevForm) => ({
            ...prevForm,
            [name]: null
          }));
          toast.error('Los contratos cotizados se deberán limitar a solo 92 días de largo.\n');
          return;
        }
      }

      setCondicionesContrato((prevForm) => ({
        ...prevForm,
        [name]: moment(value).set({ hour: 0, minute: 0, second: 0 }).format('yyyy-MM-DD HH:mm:ss')
      }));
    }
  };

  const onClickPedirAut = () => solicitarAutorizacion();

  const handleAjustePrimeraConexion = () => {
    ajustarPrimeraConexion({
      variables: {
        idEvaluacion: idEvaluacion
      }
    });
  };

  const handleAjusteDiasCorrido = () => {
    ajustarFechaHastaDiasCorrido({
      variables: {
        idEvaluacion: idEvaluacion
      }
    });
  };

  const validatedInputs = useMemo(() => {
    return structuredClone(inputGroups).map((group) => {
      return {
        ...group,
        inputs: group.inputs.map((input) => {
          const today = new moment(new Date()).format('YYYY-MM-DD');
          const desde = moment(condicionesContrato.fechaDesde);
          const hasta = moment(condicionesContrato.fechaHasta);
          const diasCorrido = moment(condicionesContrato.diasCorridosContrato);
          const diasContrato = hasta.diff(desde, 'days');
          // tanto para la fecha desde como para la fecha hasta, se debe validar que no se pueda editar 
          // si el presupuesto ya fue enviado o si el resultado del presupuesto es aprobado
          switch (input.name) {
            case 'fechaDesde':
              input.disabled = fullFormData.gestionPresupuestos.fechaEnvioPresupuesto != null &&
                condicionesContrato.fechaDesde != null ||
                origen === 'PR' ||
                origen === 'PP' && fullFormData.gestionPresupuestos.idResultadoPresupuesto === RESULTADO_PRESUPUESTO_APROBADO;
              break;
            case 'fechaHasta':
              input.disabled = fullFormData.gestionPresupuestos.fechaEnvioPresupuesto != null &&
                condicionesContrato.fechaHasta != null ||
                origen === 'PR' ||
                origen === 'PP' && fullFormData.gestionPresupuestos.idResultadoPresupuesto === RESULTADO_PRESUPUESTO_APROBADO;
              break;
            case 'observacion':
              input.hidden = !(condicionesContrato.precioDiario < condicionesContrato.precioControl && !condicionesContrato.cotizado);
              input.required = !input.hidden;
              input.disabled = autControlInProgress;
              break;
            case 'pedirAutorizacion':
              input.hidden = !(condicionesContrato.precioDiario < condicionesContrato.precioControl && !condicionesContrato.cotizado);
              break;
            case 'ajustarPrimeraConexion':
              input.onClick = handleAjustePrimeraConexion;
              input.disabled = !allowedWrite || diasCorrido != diasContrato;
              input.hidden = fullFormData.gestionPresupuestos.fechaEnvioPresupuesto == null ||
                !(today >= condicionesContrato?.fechaDesde && today <= condicionesContrato?.fechaHasta);
              break;
            case 'ajustarPorConexion':
              const todayMoment = moment(new Date());
              const diasVigentes = todayMoment.diff(desde, 'days');

              input.onClick = handleAjusteDiasCorrido;
              input.disabled = !allowedWrite;
              input.hidden = fullFormData.gestionPresupuestos.fechaEnvioPresupuesto == null ||
                diasVigentes < Math.round(diasContrato * 0.9) ||
                !(today >= condicionesContrato?.fechaDesde && today <= condicionesContrato?.fechaHasta);
              break;
            case 'space':
              input.hidden = fullFormData.gestionPresupuestos.fechaEnvioPresupuesto != null;
              break;
            default:
              break;
          }
          if (!contratoEditable && input.name != 'ajustarPrimeraConexion' && input.name != 'ajustarPorConexion') {
            input.disabled = true;
          }
          return input;
        })
      };
    });
  }, [
    condicionesContrato.precioDiario,
    condicionesContrato.precioControl,
    condicionesContrato.estadoPrecio,
    condicionesContrato.cotizado,
    autControlInProgress,
    contratoEditable,
    fechaDiasCorrido,
    fechaPrimeraConexion,
    fullFormData.gestionPresupuestos.fechaEnvioPresupuesto,
    fullFormData.gestionPresupuestos.idResultadoPresupuesto,
    editaFechaHasta,
    allowedWrite,
    condicionesContrato.fechaDesde,
    condicionesContrato.fechaHasta]
  );

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [condicionesContrato, setDataSubmissionCallback, validatedInputs]);

  if (pageLoading) {
    return (
      <div className='tab-loading-section-contrato'>
        <CircularProgress />
      </div>);

  }

  return <div>
    <Grid
      container
      columnSpacing={3}
      rowSpacing={3}
      columns={100}>

      {validatedInputs.map((group, grIndex) =>
        <GroupedContainer key={grIndex} ungrouped={!group.name} sectionTitle={group.name}>
          {group.inputs.
            filter((input) => !input.hidden).
            map((input, index) => {
              return (
                <Fragment key={`name-${input.name}-index${index}`}>
                  {input.name !== 'pedirAutorizacion' && <RenderInputsRowByType
                    key={`name-${input.name}-index${index}`}
                    input={input}
                    value={condicionesContrato[input.name]}
                    handleChange={handleChange} />
                  }
                  {input.name === 'pedirAutorizacion' &&
                    <Grid size={{ xs: 100, sm: 50, md: input.col }}>
                      <CustomButton
                        onClick={onClickPedirAut}
                        isLoading={solicitarLoading}
                        fullWidth
                        disabled={input.disabled || !condicionesContrato.observacion || autControlInProgress || !idEvaluacion}
                        className='button-notificar-coordinacion'>

                        {input.displayName}
                      </CustomButton>
                    </Grid>
                  }
                </Fragment>);

            })}
        </GroupedContainer>
      )}
    </Grid>
  </div>;
};

const inputGroups = [
  {
    inputs: [
      //ROW
      {
        displayName: 'Fecha desde',
        name: 'fechaDesde',
        type: 'date',
        disabled: true,
        col: 16
      },
      {
        displayName: 'Fecha hasta',
        name: 'fechaHasta',
        type: 'date',
        disabled: false,
        col: 16
      },
      {
        displayName: 'Días de contrato',
        name: 'diasContrato',
        type: 'int',
        disabled: true,
        col: 10
      },
      {
        displayName: 'Días de tratamiento',
        name: 'diasTratamiento',
        type: 'select',
        options: [
          { id: 1, displayName: 1 },
          { id: 2, displayName: 2 },
          { id: 3, displayName: 3 },
          { id: 4, displayName: 4 },
          { id: 5, displayName: 5 },
          { id: 6, displayName: 6 },
          { id: 7, displayName: 7 }],

        disabled: false,
        col: 10
      },
      {
        displayName: 'Ajustar Primera Conexión',
        name: 'ajustarPrimeraConexion',
        type: 'button',
        col: 24,
        onClick: null
      },
      {
        displayName: 'Ajustar por Conexión',
        name: 'ajustarPorConexion',
        type: 'button',
        col: 24,
        onClick: null
      },
      {
        name: 'space',
        type: 'item',
        hidden: true,
        col: 48
      },
      //ROW
      {
        displayName: 'Condición de pago Cliente',
        name: 'condicionClienteDesc',
        type: 'string',
        disabled: true,
        col: 30
      }]

  },
  {
    name: 'Precio',
    inputs: [
      {
        displayName: 'Estado Precio',
        name: 'estadoPrecio',
        type: 'select',
        options: [
          { id: 0, displayName: '' },
          { id: 1, displayName: 'Pendiente' },
          { id: 2, displayName: 'Aprobado' },
          { id: 3, displayName: 'Rechazado' }],

        disabled: true,
        col: 20
      },
      {
        displayName: 'Precio diario',
        name: 'precioDiario',
        type: 'currency',
        disabled: true,
        col: 17
      },
      {
        displayName: 'Tipo de Precio',
        name: 'tipoPrecio',
        type: 'string',
        disabled: true,
        col: 16
      },
      {
        displayName: 'Vigencia',
        name: 'vigencia',
        type: 'string',
        disabled: true,
        col: 30
      },
      {
        displayName: 'Precio Control',
        name: 'precioControl',
        type: 'currency',
        disabled: true,
        col: 17
      }]

  },
  {
    inputs: [
      //ROW
      {
        displayName: 'Observación Precio Control',
        name: 'observacion',
        type: 'string',
        disabled: false,
        required: true,
        col: 70
      },
      {
        displayName: 'Pedir Autorización',
        name: 'pedirAutorizacion',
        type: 'button',
        onClick: null,
        col: 30
      },
      //ROW
      {
        displayName: 'Cotizado',
        name: 'cotizado',
        type: 'boolean',
        disabled: true,
        flexDirectionRow: true,
        col: 100
      },
      //ROW
      {
        displayName: 'Ajuste Fact. Prestación',
        name: 'ajustePrestacion',
        type: 'boolean',
        disabled: false,
        flexDirectionRow: true,
        col: 100
      },
      //ROW
      {
        displayName: 'Condicional',
        name: 'condicional',
        type: 'string',
        disabled: true,
        col: 50
      }]

  }];